import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { fetchDashboard } from '../actions/dashboard'

import { setModal } from '../actions/modal'

import Loading from '../components/common/loading'

class Dashboard extends Component {
  constructor(props) {
    super(props)

    this.state = {
      enableEvents: true,
      selectedRider: undefined
    }
  }

  componentWillMount() {
    this.props.fetchDashboard()
  }

  componentWillReceiveProps(nextProps) {
    const { event, rider } = nextProps

    if (event.createdEventId !== this.props.event.createdEventId) {
      this.props.history.replace({pathname: `/event/${event.createdEventId}`})
    }

    if (rider.createdRiderId !== this.props.rider.createdRiderId) {
      this.props.history.replace({pathname: `/rider/${rider.createdRiderId}`})
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { dashboard } = nextProps

    if (dashboard !== this.props.dashboard) return true
    if (nextState !== this.state) return true
    return false
  }

  mapRiderRequests(items) {
    const { dashboard } = this.props
    const { riders } = dashboard
    const { selectedRider } = this.state

    return items.map((item, index) => (
      <li key={index} onClick={() => this.props.setModal('EventFulfillRiderRequestModal', {riderRequest: item, riders})}>
        <a>
          <span className="title">
            {item.title}
          </span>

          <span className="description">
            <small>Event: {item.event.title}</small>
            <small>Stage: {item.stage.title}</small>
          </span>
        </a>
      </li>
    ))
  }

  mapItems(items, type) {
    return items.map((item, index) => (
      <li key={index}>
        <Link to={`/${type}/${item.id}`}>
          <span className="title">
            {item.title}
          </span>

          <span className="description">
            <small>Artist: {item.artist}</small>
            <small>Owner: {item.owner}</small>
          </span>
        </Link>
      </li>
    ))
  }

  renderRiderRequests(requests) {
    if (requests.length === 0) return null

    return (
      <section>
        <h3>Rider requests</h3>

        <ul className="library-list library-list--riders">
          {this.mapRiderRequests(requests)}
        </ul>

        <h3>Events</h3>
      </section>
    )
  }

  renderEvents(events, riderRequests) {
    return (
      <section>
        <h2>Events</h2>

        {this.renderRiderRequests(riderRequests)}

        <ul className="library-list">
          {this.mapItems(events, 'event')}

          <li className="add" onClick={() => this.props.setModal('EventCreateModal')}>
            <h1>+</h1>
          </li>
        </ul>
      </section>
    )
  }

  renderRiders(riders) {
    return (
      <section>
        <h2>Riders</h2>

        <ul className="library-list library-list--riders">
          {this.mapItems(riders, 'rider')}

          <li className="add" onClick={() => this.props.setModal('RiderCreateModal')}>
            <h1>+</h1>
          </li>
        </ul>
      </section>
    )
  }

  render() {
    const { dashboard } = this.props
    const { events, riders, riderRequests } = dashboard

    if (Object.keys(dashboard).length === 0 || dashboard.isFetching === true) return (
      <Loading
        className="library"
        message="We are loading up your riders and events" />
    )

    return (
      <div className="library">
        {
          this.state.enableEvents
          ? this.renderEvents(events, riderRequests)
          : null
        }

        {this.renderRiders(riders)}
      </div>
    )
  }
}

Dashboard.propTypes = {
  dashboard: PropTypes.object,
  fetchDashboard: PropTypes.func,
  event: PropTypes.object,
  rider: PropTypes.object,
  setModal: PropTypes.func
}

Dashboard.defaultProps = {
  dashboard: {},
  fetchDashboard: function() {},
  event: {},
  rider: {},
  setModal: function() {}
}

export const mapStateToProps = (state) => {
  return {
    dashboard: state.dashboard,
    event: state.event,
    rider: state.rider
  }
}

export const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    fetchDashboard,
    setModal
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard)



// WEBPACK FOOTER //
// ./src/containers/dashboard.js